import { render, staticRenderFns } from "./DashboardBox.vue?vue&type=template&id=16cbbe86&"
import script from "./DashboardBox.vue?vue&type=script&lang=js&"
export * from "./DashboardBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports